"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=()=>{var e;let n;const i="undefined"!=typeof window&&(null===(e=null===window||void 0===window?void 0:window.navigator)||void 0===e?void 0:e.userAgent);return i&&(n=i.indexOf("Firefox")>-1?"firefox":i.indexOf("SamsungBrowser")>-1?"samsung":i.indexOf("Opera")>-1||i.indexOf("OPR")>-1?"opera":i.indexOf("Trident")>-1?"ie":i.indexOf("Edge")>-1?"edge":i.indexOf("Chrome")>-1||navigator.userAgent.indexOf("CriOS")>-1?"chrome":i.indexOf("Safari")>-1?"safari":"unknown"),n};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/DeviceDetection/getBrowser.js
// module id = 893
// module chunks = 0